import React, { useRef, useEffect } from 'react';
import { createChart } from './util';
import * as pdata from './powers';

function ProcChart(values) {
    const canvas = useRef(null);
    const canvas_style = {
        maxWidth: '800px', height: '600px', backgroundColor: '#FFF'
    };

    useEffect(() => {
        if(canvas.current)
            createChart(canvas.current.getContext('2d'), values);
    });

    return (
        <canvas ref={canvas} width="800" height="600" style={canvas_style}></canvas>            
    );

}

export function ProcChanceChart({ powers, procs }) {
    // Array of ints 0..100
    const recharge_values = Array(101).fill().map((_, ndx) => ndx);
    let datasets = [];
    for (const proc of procs)
        for (const power of powers) {
            datasets.push({
                label: power.name + ' w/ ' + proc.name,
                data: recharge_values.map(rch => pdata.proc_probability(proc, power, rch) * 100)
            });
        }
    let values = {
        data: {
            labels: recharge_values,
            datasets
        },
        title: 'Proc chances by recharge',
        xLabel: 'Slotted recharge',
        yLabel: 'Proc chance',
        yMax: 100
    };
    return ProcChart(values);
}

/* Calculates average proc damage as a percentage of a 
    power's base damage
*/
function proc_damage(proc, power, recharge) {
    let proc_dmg = pdata.proc_probability(proc, power, recharge) * proc.damage;
    let power_dmg = power.damage;
    if(power_dmg == 0)  // Don't divide by zero
        return 0;
    return (proc_dmg / power_dmg) * 100;
}

export function ProcDamageChart({ powers, procs }) {
    // Array of ints 0..100
    const recharge_values = Array(101).fill().map((_, ndx) => ndx);
    let datasets = [];
    for (const proc of procs)
        for (const power of powers) {
            datasets.push({
                label: power.name + ' w/ ' + proc.name,
                data: recharge_values.map(rch => proc_damage(proc, power, rch))
            });
        }
    let maxes = datasets.map(x => Math.max(...x.data));
    let max_pct = Math.max(...maxes, 100);
    if(max_pct > 100)
    {
        // Round up to a nice even number
        max_pct = Math.ceil(max_pct / 10) * 10;
    }
    let values = {
        data: {
            labels: recharge_values,
            datasets
        },
        title: 'Proc damage as a percent of base damage',
        xLabel: 'Slotted recharge',
        yLabel: 'Proc damage',
        yMax: max_pct
    };
    return ProcChart(values);
}

